module.exports = __webpack_public_path__ + "img/form_library.cd5a93a9.svg";